// extracted by css-extract-rspack-plugin
export default {"CopyButton":"jG0bT"};